import script from "./Promo.vue?vue&type=script&setup=true&lang=js"
export * from "./Promo.vue?vue&type=script&setup=true&lang=js"

import "./Promo.vue?vue&type=style&index=0&id=e412701e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e412701e"]])

export default __exports__